import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.334 3a4.96 4.96 0 0 0-3.49 1.393l-.008.008-1.449 1.44a.75.75 0 0 0 1.058 1.064l1.445-1.437a3.462 3.462 0 0 1 4.896 4.895l-2.523 2.522a3.462 3.462 0 0 1-5.22-.374.75.75 0 0 0-1.202.899 4.96 4.96 0 0 0 7.483.536l2.527-2.527.01-.01A4.962 4.962 0 0 0 16.333 3m-5.541 5.85a4.96 4.96 0 0 0-3.864 1.44l-2.527 2.528-.01.01a4.962 4.962 0 0 0 7.017 7.015l.01-.009 1.44-1.44a.75.75 0 0 0-1.06-1.06l-1.436 1.435a3.462 3.462 0 0 1-4.895-4.895L7.99 11.35a3.462 3.462 0 0 1 5.22.374.75.75 0 1 0 1.202-.899 4.96 4.96 0 0 0-3.619-1.977",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }